export const ImageProcessingEngineVersion = 34;
export const DoSmallDetailsPart = true;
